/**
 * appOperationBtnsModule
 * description: app渠道下操作按钮
 * author: Qian.qianchen 2019-03-21
 */
'use strict';
angular.module('appOperationBtnsModule', []).directive('appOperationBtns', ['modalDialog', 'trsHttpService', 'sensitiveWordCheckService', '$filter', 'newMediaService', 'appConst', 'trsspliceString', function (modalDialog, trsHttpService, sensitiveWordCheckService, $filter, newMediaService, appConst, trsspliceString) {
    return {
        restrict: 'E',
        replace: false,
        templateUrl: './editingCenter/iWo/fusionPending/directive/appOperationBtns/appOperationBtns_tpl.html',
        scope: {
            selectedArr: '=',
            callback: '&'
        },
        link: function ($scope, iElement, attrs) {
            initStatus();

            /**
             * [initStatus description] 状态初始化
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    signedSuccess: false
                };
                $scope.newOperationParams = {
                    serviceid: 'mlf_fusion',
                    methodname: 'doActionOnMediaTypeAndDocIdsSync',
                    oprType: 'daibian',
                    actionKey: '',
                    // mediaTypeDocIds: [],
                    // OprTime: $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                    // OprTimeStart: '',
                    // OprTimeEnd: '',
                };
                $scope.data = {
                    trench: 'App',
                    filterArray: [],
                };
                $scope.requestData = $scope.callback;
            }

            /** * APP操作 start ***/
            /**
             * [trialForApp description] APP送审
             * @return {[type]} [description]
             */
            $scope.trialForApp = function () {
                // modalDialog.inputModel('送审', '送审意见 (选填)', function (content) {
                //     dealOperParams();
                //     $scope.newOperationParams.actionKey = 'songshen';
                //     $scope.newOperationParams.Opinion = content;
                //     $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.newOperationParams, 'get').then(function(data) {
                //         if (angular.isArray(data.REPORTS)) {
                //             modalDialog.multiReportsAlert(data, function() {
                //                 $scope.callback();
                //             });
                //         } else {
                //             modalDialog.alertType('', data.DETAIL, 'warning', 'confirm');
                //         }
                //     }, function (data) {
                //     });
                // });
                // if ($scope.data.selectedArray.length > 1) {
                //     $scope.status.canDesignatedAuditor = false;
                // } else {
                //     $scope.status.canDesignatedAuditor = true;
                // }
                $scope.data.selectedArray = $scope.selectedArr;
                $scope.loadingPromise = newMediaService.trial($scope, appConst.params.trialParams);
            };

            /**
             * [initStatus description] 状态初始化
             * @return {[type]} [description]
             */
            function dealOperParams() {
                $scope.newOperationParams.mediaTypeDocIds = [];
                $scope.selectedArr.forEach((item) => {
                    $scope.newOperationParams.mediaTypeDocIds.push({
                        MEDIATYPE: item.MEDIATYPE,
                        DOCID: item.METADATAID
                    });
                });
                $scope.newOperationParams.mediaTypeDocIds = JSON.stringify($scope.newOperationParams.mediaTypeDocIds);
            }
            $scope.directSignedForApp = function () {
                var allPushHeadDraft = hasPushHeadDraft();
                if (allPushHeadDraft) {
                    modalDialog.alertType('推头条稿件不可进行签发！', '', 'error', false);
                    return;
                }
                sensitiveWordCheckService.SensitiveWordsAndCareful($scope.data.filterArray, '', '1').then(function () {
                    $scope.status.signedSuccess = true;
                    signedForApp();
                }, function () {
                    modalDialog.confirmModal('签发', '确认直接签发?', function () {
                        signedForApp();
                    });
                });

            };

            /**
             * [hasPushHeadDraft description] 判断所选稿件中是否存在推头条稿件
             * @return {Boolean} [description]
             */
            function hasPushHeadDraft() {
                var allPushHeadDraft = false;
                $scope.data.filterArray = [];
                for (var i = 0; i < $scope.selectedArr.length; i++) {
                    if ($scope.selectedArr[i].METADATAID == '884193') {
                        $scope.selectedArr[i].PUSHHEADLINETYPE = '2';
                    }
                    if ($scope.selectedArr[i].PUSHHEADLINETYPE != '2') {
                        // 非头条稿件可进行签发操作
                        $scope.data.filterArray.push($scope.selectedArr[i]);

                    }
                }
                if ($scope.data.filterArray.length === 0) {
                    allPushHeadDraft = true;
                }
                return allPushHeadDraft;
            }

            /**
             * [signed description]直接签发函数
             * @return {[type]}      [description]
             */
            function signedForApp() {
                // var array = $scope.data.filterArray;
                dealOperParams();
                $scope.newOperationParams.actionKey = 'qianfa';
                // var params = {
                //     serviceid: 'mlf_appoper',
                //     methodname: 'appDaiBianPublish',
                //     ObjectIds: trsspliceString.spliceString(array, 'CHNLDOCID', ','),
                //     ChnlDocIds: trsspliceString.spliceString(array, 'CHNLDOCID', ','),
                //     MetaDataIds: trsspliceString.spliceString(array, 'METADATAID', ','),
                // };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.newOperationParams, 'get').then(function (data) {
                    if ($scope.status.signedSuccess) {
                        modalDialog.multiReportsAlert(data, '');
                        $scope.callback();

                    } else {
                        modalDialog.alertType('签发成功', '', 'success', false, function () {
                            $scope.callback();

                        });
                    }
                    $scope.status.signedSuccess = false;
                }, function (result) {
                    $scope.callback();
                    // result.REPORTS = result.REPORTS.filter(function (value, key) {
                    //     return result.REPORTS[key].TITLE === '排重信息';
                    // });
                    // if (result.REPORTS.length > 0) {
                    //     delete params.ObjectIds;
                    //     delete params.ChnlDocIds;
                    //     delete params.MetaDataIds;
                    //     var failTemp = $filter('pick')(angular.copy(result.REPORTS), $scope.reportsFilter);
                    //     var successTemp = $filter('pick')(angular.copy(result.REPORTS), $scope.successReportsFilter);
                    //     var newResult = {
                    //         reports: failTemp,
                    //         params: params,
                    //         errorData: result,
                    //         successReports: successTemp,
                    //     };
                    //     angular.forEach(newResult.reports, function (data, index) {
                    //         angular.forEach(array, function (value, key) {
                    //             if (data.RESULT.DOC.METADATAID == value.METADATAID) {
                    //                 data.RESULT.DOC.ObjectIds = value.CHNLDOCID;
                    //                 data.RESULT.DOC.ChnlDocIds = value.CHNLDOCID;
                    //                 data.RESULT.DOC.METADATAID = value.METADATAID;
                    //             }
                    //         });
                    //     });
                    //     newResult.params.siteid = $scope.selectedArr[0].SIDEID;
                    //     newResult.params.doctype = $scope.selectedArr[0].DOCTYPEID - 1;
                    //     delete newResult.successReports;
                    //     editingCenterAppService.singZpInfo(newResult, function () {
                    //         $scope.callback();

                    //     }, function () {
                    //         $scope.callback();

                    //     });
                    //     $scope.status.signedSuccess = false;
                    // } else {
                    //     // modalDialog.multiReportsAlert(result, function() {
                    //     // $scope.callback();
                    //     // });
                    // }
                });
            }

            /**
             * [reponseFilter description]过滤返回的reports
             * @param  {[obj]} elm [description]各个返回的report
             * @return {[null]}     [description]
             */
            $scope.reportsFilter = function (elm) {
                if (angular.isDefined(elm)) {
                    return elm.ISSUCCESS == 'false';
                }
            };

            /**
             * [successReportsFilter description]过滤返回的签发成功项
             * @param  {[obj]} elm [description]返回的report
             * @return {[type]}     [description]
             */
            $scope.successReportsFilter = function (elm) {
                if (angular.isDefined(elm)) {
                    return elm.ISSUCCESS == 'true';
                }
            };
            $scope.timingSignedForApp = function () {
                var allPushHeadDraft = hasPushHeadDraft();
                if (allPushHeadDraft) {
                    modalDialog.alertType('推头条稿件不可进行签发！', '', 'error', false);
                    return;
                }
                sensitiveWordCheckService.SensitiveWordsAndCarefulTiming($scope.data.filterArray, '').then(function () { }, function () {
                    timeSignForApp();
                });
            };

            /**
             * [timeSign description]定时签发函数
             * @param  {[obj]} item [description]稿件具体信息
             * @return {[type]}      [description]
             */
            function timeSignForApp(item) {
                // var array = $scope.data.filterArray;
                // var params = {
                //     selectedArray: array,
                //     isNewDraft: false,
                //     serviceid: 'mlf_appoper',
                //     methodname: 'appDaiBianTimingPublish'
                // };
                // dealOperParams();
                // $scope.newOperationParams.selectedArray = array;
                // $scope.newOperationParams.actionKey = 'dingshiqianfa';
                // $scope.loadingPromise = editingCenterService.draftTimeSinged($scope.newOperationParams).then(function (data) {
                //     modalDialog.alertType('定时签发成功', '', 'success', false, function () {
                //         $scope.callback();
                //     });
                // }, function (result) {
                //     $scope.callback();
                    
                // });
                $scope.data.selectedArray = $scope.selectedArr;
                $scope.loadingPromise = newMediaService.timeSign($scope, appConst.params.daibianTimeSign, signCallBack);
            }

            /**
             * [signCallBack description] 签发回调, 组装强制签发参数
             * @param   {[type]}  params  [params description]
             * @param   {[type]}  array   [array description]
             * @return  {[type]}          [return description]
             */
            function signCallBack(params, array) {
                var ChnlDocIds = [];
                var ObjectIds = [];
                var MetaDataIds = [];
                for (var i = 0; i < array.length; i++) {
                    ChnlDocIds.push(array[i].DOC.CHNLDOCID);
                    ObjectIds.push(array[i].DOC.CHNLDOCID);
                    MetaDataIds.push(array[i].DOC.METADATAID);
                }
                params.ChnlDocIds = ChnlDocIds.join(',');
                params.ObjectIds = ObjectIds.join(',');
                params.MetaDataIds = MetaDataIds.join(',');
            }

            /** * APP操作 end ***/

        }
    };
}]);
